// extracted by mini-css-extract-plugin
export default {"titleContainer":"index_snow_titleContainer__ltWBv"};